import "./App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ChatWidget } from "./components/ChatWidget";

const ENABLE_ADMIN = process.env.REACT_APP_ENABLE_ADMIN === "true";

// Public pages ship in the main bundle; the whole admin area (incl. recharts)
// is code-split so visitors never download it.
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const Blog = lazy(() => import("./pages/Blog"));
const Contact = lazy(() => import("./pages/Contact"));
const CompanyProfile = lazy(() => import("./pages/CompanyProfile"));

const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout"));
const Dashboard = lazy(() => import("./pages/admin/Dashboard"));
const DocumentList = lazy(() => import("./pages/admin/DocumentList"));
const InvoiceCreate = lazy(() => import("./pages/admin/InvoiceCreate"));
const KwitansiCreate = lazy(() => import("./pages/admin/KwitansiCreate"));
const DocumentView = lazy(() => import("./pages/admin/DocumentView"));
const SuratList = lazy(() => import("./pages/admin/SuratList"));
const SuratCreate = lazy(() => import("./pages/admin/SuratCreate"));
const SuratView = lazy(() => import("./pages/admin/SuratView"));
const SPK = lazy(() => import("./pages/admin/SPK"));
const Kas = lazy(() => import("./pages/admin/Kas"));
const Barang = lazy(() => import("./pages/admin/Barang"));
const Anggota = lazy(() => import("./pages/admin/Anggota"));

function PublicLayout({ children }) {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-[#060d1a]">
      <Navbar />
      <main key={location.pathname} className="page-enter">{children}</main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense
          fallback={
            <div className="min-h-screen bg-[#060d1a] flex items-center justify-center text-slate-400 text-sm">
              Memuat…
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/tentang" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/layanan" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/portofolio" element={<PublicLayout><Portfolio /></PublicLayout>} />
            <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
            <Route path="/kontak" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/company-profile" element={<CompanyProfile />} />

            {/* Admin — only mounted when REACT_APP_ENABLE_ADMIN=true (demo/legacy or local dev) */}
            {ENABLE_ADMIN && (<>
              <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="dokumen" element={<DocumentList />} />
              <Route path="invoice/baru" element={<InvoiceCreate />} />
              <Route path="kwitansi/baru" element={<KwitansiCreate />} />
              <Route path="surat" element={<SuratList />} />
              <Route path="surat/baru" element={<SuratCreate />} />
              <Route path="surat/edit/:id" element={<SuratCreate />} />
              <Route path="surat/:id" element={<SuratView />} />
              <Route path="spk" element={<SPK />} />
              <Route path="kas" element={<Kas />} />
              <Route path="barang" element={<Barang />} />
              <Route path="anggota" element={<Anggota />} />
              <Route path="dokumen/:id" element={<DocumentView />} />
            </Route>
            </>)}
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
